import { type ArticleCardProps } from '3-components/Cards/CardArticle/CardArticle';
import { type PeopleListingQuery } from 'cms/cms';
import { type ContentModelReference, type PersonPage } from 'cms/cms-types';
import { resolvePersonPagesToPeopleCards, type PersonPageItems, type PeopleCardResolverSettings, type PersonPageResult } from './peopleCardResolver';

interface PeopleListingData {
    total: number;
    items: ArticleCardProps[];
}

interface PeopleListingResolverSettings extends PeopleCardResolverSettings {
    filterByGuid?: string[];
}

const filterItemsByGuid = (filterString: string[], items: PersonPage[]): PersonPageItems => {
    const filteredItems: PersonPageItems = [];
    filterString.forEach(value => {
        const item = items.find(({ ContentLink }) => {
            const { GuidValue } = ContentLink as ContentModelReference;
            return GuidValue === value;
        });

        if (item) {
            filteredItems.push(item);
        }
    });

    return filteredItems;
};

export const resolvePeopleListing = (data: PeopleListingQuery, settings: PeopleListingResolverSettings): PeopleListingData | null => {
    const { items, total } = data.PersonPage as PersonPageResult;
    const { filterByGuid } = settings;

    const filteredItems = filterByGuid ? filterItemsByGuid(filterByGuid, items as PersonPage[]) : items;

    return {
        total: Number(total),
        items: resolvePersonPagesToPeopleCards(filteredItems as PersonPageItems, settings),
    };
};
